import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=44fa36b1&scoped=true"
import script from "./manage.vue?vue&type=script&lang=ts"
export * from "./manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fa36b1",
  null
  
)

export default component.exports